export const getCensorEmail = email => {
  if (!email) {
    return "";
  } else {
    let parts = email.split("@");
    if (parts.length == 2) {
      return (
        parts[0].substring(0, 1) +
        "***" +
        parts[0].substring(parts[0].length - 1, parts[0].length) +
        "@" +
        parts[1]
      );
    }
    return "";
  }
};

export const getCensorEmailMessage = email => {
  return "<p><strong>(" + getCensorEmail(email) + ")</strong></p>";
};



// WEBPACK FOOTER //
// ./components/twoFA/utils.js